import { MdCheckCircleOutline, MdErrorOutline, MdInfoOutline, MdWarningAmber } from "react-icons/md";

const TONES = {
  info: { className: "bg-info-subtle text-info-fg border-info/20", icon: MdInfoOutline },
  success: { className: "bg-success-subtle text-success-fg border-success/20", icon: MdCheckCircleOutline },
  warning: { className: "bg-warning-subtle text-warning-fg border-warning/20", icon: MdWarningAmber },
  danger: { className: "bg-danger-subtle text-danger-fg border-danger/20", icon: MdErrorOutline },
};

const LEGACY_STATE_TONES = { error: "danger", success: "success" };

/**
 * Inline status banner.
 *
 * @param {object} props
 * @param {"info"|"success"|"warning"|"danger"} [props.tone="info"] danger/warning announce as
 *   role="alert"; info/success as role="status".
 * @param {"error"|"success"|"info"} [props.state] Legacy alias for `tone` (error → danger).
 * @param {React.ReactNode} [props.title] Optional bold first line.
 * @param {React.ReactNode} props.children Message body.
 * @param {string} [props.className="mb-4"] Outer spacing/overrides.
 */
const AlertPane = ({ tone, state, title, children, className = "mb-4" }) => {
  const resolvedTone = tone || LEGACY_STATE_TONES[state] || "info";
  const { className: toneClass, icon: Icon } = TONES[resolvedTone] || TONES.info;
  const urgent = resolvedTone === "danger" || resolvedTone === "warning";

  return (
    <div
      role={urgent ? "alert" : "status"}
      className={`flex items-start gap-2 rounded-control border p-4 text-sm ${toneClass} ${className}`.trim()}
    >
      <Icon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0" />
      <div className="flex-1">
        {title && <p className="font-semibold">{title}</p>}
        {children && <div className={title ? "mt-1" : undefined}>{children}</div>}
      </div>
    </div>
  );
};

export default AlertPane;
